import api from "@modules/JourneyBuilder/api";
import {timeUnit} from '@core/Util/time';

const timeUnitLabelLookup = Object.keys(timeUnit)
    .reduce((lookup, label) => {
        lookup[timeUnit[label]] = label;
        return lookup;
    }, {});

/**
 * Generate an inclusive range from {start} to {end}
 * @param {Number} start
 * @param {Number} end
 * @return {Number[]}
 */
const generateRange = (start, end) => {
    const range = [];
    for(let i = start; i <= end; i++) {
        range.push(i);
    }
    return range;
};

/**
 * HTML Sanitize the given text
 * @param {String|undefined} text
 * @return {string}
 */
const sanitizeHtml = text => {
    if(text === undefined) {
        text = '';
    }

    const el = document.createElement('span');
    el.innerText = text;
    return el.innerHTML;
};

/** @returns {Promise<{ get: function(key: String):String }>} */
function getFilterLabelMap(){
    if(getFilterLabelMap._cachedResult) {
        return getFilterLabelMap._cachedResult;
    }

    return getFilterLabelMap._cachedResult = new Promise(async resolve => {
        /** @type {Map<String, String>} */
        const map = new Map();

        try {
            const fieldTypes = await api.getAudienceFilterFieldTypes();

            fieldTypes.forEach(({id, type, label, value}) => {
                map.set(type, label); //Label = type label
                map.set(id, value);   //Value = item label            
            });
        } catch (e) {
            //Should never occur
            getFilterLabelMap._cachedResult = undefined;
        }

        //Worst case - keys as labels :(
        resolve({
            get: key => map.get(key) || key || ''
        });
    });
}


/**
 * Checkpoint tooltip list element builder
 */
class ListElementBuilder {
    constructor() {
        this._rootElement = document.createElement('ul');
    }

    /**
     * Create a nested list appending it at the current position to the current list element
     * @return {ListElementBuilder}
     */
    createdNestedList() {
        const childList = new ListElementBuilder();
        this._rootElement.appendChild(childList._rootElement);
        return childList;
    }

    /**
     * Add a listitem to the current list element
     * @param {String} text
     * @return {ListElementBuilder}
     */
    add(text) {
        const el = document.createElement('li');
        el.innerText = text;
        this._rootElement.appendChild(el);
        return this;
    }

    /**
     * Get the amount of elements contained within the list element
     * @return {number}
     */
    get count() {
        return this._rootElement.childElementCount;
    }

    toString() {
        if(this.count === 0) {
            return '';
        }

        return this._rootElement.outerHTML;
    }
}

export {
    ListElementBuilder,

    timeUnitLabelLookup,
    
    getFilterLabelMap,
    generateRange,
    sanitizeHtml
}
